module.exports = __webpack_public_path__ + "b2655f81d24064d709b1fb33c9c48520.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-header/sp-header.html
// module id = 1119
// module chunks = 0